import { Ward } from '@iot-platform/models/oyan';

/** A ward can be removed only when it has no receivers linked. */
export function canRemoveWard(ward: Ward): boolean {
  return (ward?.receivers?.length ?? ward?.totalReceivers ?? 0) === 0;
}

export function withCanRemoveWard(ward: Ward): Ward {
  return { ...ward, canRemoveWard: canRemoveWard(ward) };
}
